import styled from 'styled-components';

export const Section = styled.div`
  padding: 40px;
`;

export const SectionName = styled.div`
  margin-bottom: 32px;
`;

export const Actions = styled.div`
  text-align: right;
  margin-top: 1em;
`;

export const Editor = styled.div`
  margin-top: 1em;
  margin-left: 1em;
`;

export const ProjectSettingsSection = styled.div`
  background-color: var(--ds-surface, var(--ds-fb-surface));
  margin-top: 56px;
`;

export const JiraAdminSettingsSection = styled.div`
  background-color: var(--ds-surface, var(--ds-fb-surface));
`;

export const SectionBox = styled.div`
  background-color: var(--ds-surface, var(--ds-fb-surface));
  margin-bottom: 1em;
`;

export const SectionBoxContent = styled.div`
  position: relative;
`;

export const LoadingWrapper = styled.div`
  background-color: var(--ds-surface, var(--ds-fb-surface));
  opacity: 0.5;
  transition: opacity 0.2s, visibility 0.2s;
  transition-delay: 0.1s;
  height: 100%;
  left: 0px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2500;
`;

export const Icons = styled.div`
  float: right;
`;
